import { useMemo } from "react";
import { type LegendProps, useLegend } from "../hooks/useLegend";
import styles from "./MapLegend.module.scss";
import { getWidthAdjustedSVG } from "./utils";

export const ColorMapLegend = ({ parameter, style }: LegendProps) => {
  const { data: legend } = useLegend({ parameter, style });

  const svg = useMemo(() => {
    if (legend) {
      const widthAdjustedLegend = getWidthAdjustedSVG(legend);

      if (widthAdjustedLegend) {
        const serializer = new XMLSerializer();
        return serializer.serializeToString(widthAdjustedLegend);
      }
    }
  }, [legend]);

  if (!svg) {
    return <></>;
  }

  return (
    <div
      className={styles["map-legend"]}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: Not cool, but it's safe
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};
